import React, { Component, Fragment } from 'react';

import Select from 'react-select';

const ActionsReadOnlyEmptyStateSearch  = ({context}) =>  {

    const options = context.actionsRedux.projectFunctionsReadOnly.map(project => ({value:project.id, label:project.name}) );

    return (
      <Fragment>
        <Select
          isSearchable={true}
          options={options}
          onChange={(selectedProject) => {
            const project = context.actionsRedux.projectFunctionsReadOnly.find(project => project.id === selectedProject.value);
            context.selectProject(project);
          }}

        />
      </Fragment>
    );
  
}

export default ActionsReadOnlyEmptyStateSearch;